/* global ENV_CONFIG */
import biLogger from 'web-bi-logger';
import { attempt } from 'shared/utils/attempt';
import events from 'shared/bi/events';
import userTransactions from 'shared/bi/user-transactions';
import { getVisitorId } from './bi-vod';


const WixSDK = window.Wix;

const VOD_SRC_ID = 71;

const knownEvents = _.mapValues(events, evid => ({ evid }));

const defaults = {
  src: VOD_SRC_ID,
  biToken: attempt(() => WixSDK.Utils.getInstanceValue('biToken')), // same as sid, but we use biToken everywhere
  videoInstanceID: attempt(() => WixSDK.Utils.getInstanceId()),
  compId: attempt(() => WixSDK.Utils.getOrigCompId()) || attempt(() => WixSDK.Utils.getCompId()),
};

const biFactory = biLogger
  .factory({ endpoint: 'video' })
  .setDefaults(defaults)
  .setEvents(knownEvents);

if (ENV_CONFIG.disableBi) {
  biFactory._publishers.splice(0, 1);
}

if (ENV_CONFIG.logBiSend) {
  biFactory.addPublisher(event => {
    console.warn('bi:', _.findKey(knownEvents, { evid: event.evid }), event); // eslint-disable-line no-console
  });
}

const biLoggerInstance = biFactory.logger();

/*
  @param eventName
  @param options
  @param options.previousEventName - use this one for transactions, aka:
  if @previousEventName is set to 'widget.show.requested' event will not fire if previousEvent was not fired yet.
  there is a contract on transaction starting events to end with '.requested'
 */
biLoggerInstance.logWidgetSystem = (eventName, { previousEventName } = {}) => {
  if (userTransactions.isTransaction({ eventName, previousEventName })) {
    const shouldSendEvent = userTransactions.getTransactionResult({ eventName });
    if (!shouldSendEvent) {
      return;
    }
  }

  biLoggerInstance.log('widget-system', {
    eventName,
    visitorID: getVisitorId(),
  });
};

export default biLoggerInstance;



// WEBPACK FOOTER //
// ./src/shared/bi/bi.js